import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../../../environments/environment';
import { LaboratoryComponent } from './laboratory.component';
import { PoprModalLaboratoryComponent } from './modal/popr-modal-laboratory.component';
import { PoprToastLaboratoryComponent } from './toast/popr-toast-laboratory.component';
import { SampleComponent } from './modal/sample.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TwoFactorLaboratoryComponent } from './two-factor/two-factor-laboratory.component';
import { ChevronIcon, IconModule, IconRegistry } from '@ciam/library';

const routes: Routes = [
  {
    path: '',
    component: LaboratoryComponent,
    children: [
      { path: '', redirectTo: 'toast' },
      { path: 'toast', component: PoprToastLaboratoryComponent },
      { path: 'modal', component: PoprModalLaboratoryComponent },
      { path: '2fa', component: TwoFactorLaboratoryComponent }
    ],
  }
];

@NgModule({
  declarations: [
    LaboratoryComponent,
    SampleComponent,
    PoprModalLaboratoryComponent,
    PoprToastLaboratoryComponent,
    TwoFactorLaboratoryComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        RouterModule.forChild(environment.production ? [] : routes),
        IconModule,
    ]
})

export class LaboratoryModule {
  constructor(private iconRegistry: IconRegistry) {
    this.iconRegistry.register(
      ChevronIcon
    );
  }
}
